import apiClient, { ApiResponse } from './client';
import type { SupportedLanguage } from '@/lib/i18n';

/** The suggestion speaks every Shop Language. */
export type SuggestionLanguage = SupportedLanguage;

export interface DesignSuggestionPosition {
  /** Position key of the decorated side, e.g. `front` or `back`. */
  positionKey: string;
  /** Cropped design image of the position (http(s) URL or data URL); absent when no crop exists yet. */
  imageUrl?: string;
  /** Plain text of the text objects on the position. */
  texts: string[];
}

export interface DesignSuggestionRequest {
  language: SuggestionLanguage;
  positions: DesignSuggestionPosition[];
  categoryNames: string[];
}

export interface DesignSuggestionResult {
  title: string;
  description: string;
  tags: string[];
}

/**
 * Generate listing title, description and tags for the current design from
 * its cropped views, canvas texts and the selected product categories.
 */
export async function generateDesignSuggestion(
  payload: DesignSuggestionRequest
): Promise<DesignSuggestionResult> {
  const response = await apiClient.post<ApiResponse<DesignSuggestionResult>>(
    '/openai/design-suggestion',
    payload,
    { timeout: 120_000 }
  );
  return response.data.data;
}
